class PhoneInput extends HTMLElement {
  static PHONE_PATTERN = /^(\+41|0041|0)\s?(?:\(0\))?\s?[1-9]\d(?:[\s./-]?\d){7}$/;

  constructor() {
    super();
    this.input = document.createElement('input');
    this.input.type = 'tel';
    this.input.classList.add('input');
    this.input.autocomplete = 'tel';
    this.errorMessage = document.createElement('span');
    this.errorMessage.classList.add('form-error-message');
    this.errorMessage.setAttribute('role', 'alert');
    this.errorMessage.setAttribute('aria-live', 'polite');
  }

  _setValidity(message) {
    this.input.setCustomValidity(message);
    this.errorMessage.setAttribute('aria-hidden', message ? 'false' : 'true');

    if (message) {
      clearTimeout(this._errorClearTimer);
      this.errorMessage.textContent = message;
      this.classList.add('has-error');
      return;
    }

    this.classList.remove('has-error');
    clearTimeout(this._errorClearTimer);
    this._errorClearTimer = setTimeout(() => {
      if (!this.classList.contains('has-error')) {
        this.errorMessage.textContent = '';
      }
    }, 300);
  }

  connectedCallback() {
    if (this.hasAttribute('name')) this.input.name = this.getAttribute('name');
    if (this.hasAttribute('required')) this.input.required = true;
    if (this.hasAttribute('placeholder')) this.input.placeholder = this.getAttribute('placeholder');
    if (this.hasAttribute('value')) this.input.value = this.getAttribute('value');

    this.appendChild(this.input);
    this.appendChild(this.errorMessage);

    this.input.addEventListener('input', () => {
      this.input.value = this.input.value.replace(/[^0-9+ -]/g, '');
      this._setValidity('');
    });

    this.input.addEventListener('blur', () => {
      const value = this.input.value.trim();

      if (!value) {
        if (this.input.required) {
          this._setValidity(this.dataset.errorRequired || 'Phone number is required');
        }
        return;
      }

      if (!PhoneInput.PHONE_PATTERN.test(value)) {
        this._setValidity(this.dataset.errorInvalid || 'Wrong phone number format');
        return;
      }

      this._setValidity('');
    });
  }
}

customElements.define('phone-input', PhoneInput);
